import { Route, Redirect } from 'react-router-dom';
import cookie from './services/cookie/index.js';

const PrivateRoute = ({ component: Component, ...rest }) => {
  const username = cookie().get("username");
  const token = cookie().get("token");
  const name = cookie().get("name");

  const isAuthenticated = token && username && name;

  return (
    <Route
      {...rest}
      render={(props) =>
        isAuthenticated ? (
          <Component {...props} />
        ) : (
          <Redirect to="/login" />
        )
      }
    />
  );
};

export default PrivateRoute;
